import routerOptions0 from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}